/**
 * Amplify/axios call JSON.parse on HTTP bodies. Auth/API failures often return
 * HTML/plain text, which crashes the UI. Recover instead of throwing.
 * Imported early from App.vue so main.js stays unchanged.
 */
const nativeParse = JSON.parse.bind(JSON);

if (!JSON.parse.__rcsSafePatched) {
  const safeParse = (text, reviver) => {
    try {
      return nativeParse(text, reviver);
    } catch (error) {
      if (typeof text === "string") {
        const trimmed = text.replace(/^\uFEFF/, "").trim();
        if (!trimmed) {
          console.error("JSON.parse recovered from empty payload");
          return {};
        }

        const first = trimmed[0];
        const looksLikeJson =
          first === "{" ||
          first === "[" ||
          first === '"' ||
          trimmed === "null" ||
          trimmed === "true" ||
          trimmed === "false" ||
          /^-?\d/.test(trimmed);

        if (!looksLikeJson) {
          console.error(
            "JSON.parse recovered from non-JSON payload:",
            trimmed.slice(0, 160)
          );
          return {};
        }
      }
      throw error;
    }
  };

  safeParse.__rcsSafePatched = true;
  JSON.parse = safeParse;
}

const isJsonParseError = (error) => {
  const message = error?.message || String(error || "");
  return (
    message.includes("JSON.parse") ||
    message.includes("unexpected character at line 1 column 1") ||
    message.includes("Unexpected token") ||
    message.includes("is not valid JSON")
  );
};

window.addEventListener(
  "unhandledrejection",
  (event) => {
    if (isJsonParseError(event?.reason)) {
      console.error(
        "Suppressed JSON parse rejection:",
        event?.reason?.message || event?.reason
      );
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  },
  true
);

window.addEventListener(
  "error",
  (event) => {
    if (isJsonParseError(event?.error || event?.message)) {
      console.error(
        "Suppressed JSON parse error:",
        event?.message || event?.error
      );
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  },
  true
);
